var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01867 7.23376L1.60742 9.64501L4.01867 12.0563",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23364 4.01879L9.64489 1.60754L12.0561 4.01879",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0561 15.2712L9.64489 17.6825L7.23364 15.2712",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2712 7.23376L17.6825 9.64501L15.2712 12.0563",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60742 9.64502H17.6824",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64502 1.60754V17.6825",
    stroke: "var(--color-icon-drag-stroke,white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.29,
    height: 19.29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMove);
export default __webpack_public_path__ + "static/media/NewMove.f8b2d7555871cc637cbe3a705cc00675.svg";
export { ForwardRef as ReactComponent };